import type { AMapConstructor } from '@/types/amap'

let amapScriptPromise: Promise<void> | null = null

export function loadAMapScript(key: string, secret?: string): Promise<void> {
  if (window.AMap) return loadAMapPlugins(window.AMap as AMapConstructor)
  if (amapScriptPromise) return amapScriptPromise

  amapScriptPromise = new Promise((resolve, reject) => {
    window.forceWebGL = true
    if (secret) {
      window._AMapSecurityConfig = { securityJsCode: secret }
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = `https://webapi.amap.com/maps?v=2.0&key=${encodeURIComponent(key)}`
    script.async = true

    script.onload = () => {
      if (!window.AMap) {
        reject(new Error('高德地图 SDK 未提供 AMap 对象'))
        return
      }
      loadAMapPlugins(window.AMap as AMapConstructor).then(resolve).catch(reject)
    }

    script.onerror = () => {
      reject(new Error('高德地图SDK加载失败'))
    }

    document.head.appendChild(script)
  })

  return amapScriptPromise
}

function loadAMapPlugins(amap: AMapConstructor): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof amap.plugin !== 'function') {
      reject(new Error('高德地图插件加载能力不可用'))
      return
    }

    try {
      amap.plugin(['AMap.Geocoder', 'AMap.PlaceSearch'], resolve)
    } catch (error) {
      reject(error instanceof Error ? error : new Error('高德地图插件加载失败'))
    }
  })
}

// 声明全局类型
declare global {
  interface Window {
    AMap?: AMapConstructor
    forceWebGL?: boolean
    _AMapSecurityConfig?: {
      securityJsCode: string
    }
  }
}
